import {createContext} from 'react';

export interface ActivitySidebarContextValue {
  handleToggleTab: (tabId: string) => void;
}

export const ActivitySidebarContext = createContext<ActivitySidebarContextValue | null>(null);
